import React, { useEffect, useState } from "react";
import "./home.css";

import { motion } from "framer-motion";
import { FaPaperPlane, FaEarthAmericas, FaCar } from "react-icons/fa6";
import Aos from "aos";
import "aos/dist/aos.css";
import video from '../../assets/bg-1.mp4';
import Banner from "../Banner/Banner";

import { Helmet } from "react-helmet-async";

const Home = () => {
  const [activeTab, setActiveTab] = useState("trip");
  const [tripType, setTripType] = useState("oneway");
  const [travelTime, setTravelTime] = useState("exact");

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="home">
      {/* ✅ Meta Tags خاصة بالصفحة الرئيسية */}
      <Helmet>
        <title>Yalla Egypt Tours | Discover Egypt’s Wonders</title>
        <meta
          name="description"
          content="Book amazing Egypt tours with Yalla Egypt Tours. Explore Cairo, the Nile, Luxor, Aswan, and the Red Sea with expert guides and great deals."
        />
        <meta
          name="keywords"
          content="Egypt tours, travel Egypt, Nile cruise, Cairo tours, pyramids, Luxor, Aswan, Hurghada, Sharm El Sheikh"
        />
        <link rel="canonical" href="https://yallaegypttours.com/" />
        <meta property="og:title" content="Yalla Egypt Tours | Discover Egypt’s Wonders" />
        <meta property="og:description" content="Plan your perfect Egypt trip with trusted guides and affordable packages." />
        <meta property="og:url" content="https://yallaegypttours.com/" />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* الخلفية */}
      <Banner page="home" />
    </section>
  );
};

export default Home;
